<template>
  <div class="totalNum">
    <div class="totalNum__container">
      <!-- 左侧信息卡片 -->
      <div class="info-cards">
        <!-- 设备总数量卡片 -->
        <div class="info-card total-device">
          <div class="device-icon">?</div>
          <div class="device-info">
            <p class="info-title">设备总数量</p>
            <p class="info-count">{{ totalOnline }}</p>
          </div>
        </div>

        <!-- 离线设备卡片 -->
        <div class="info-card offline-device">
          <div class="device-icon offline">!</div>
          <div class="device-info">
            <p class="info-title">离线时间>24小时设备数量</p>
            <p class="info-count offline">{{ totalOffline }}</p>
          </div>
        </div>
      </div>

      <!-- 右侧图表 -->
      <div class="chart-container">
        <div ref="pieChart" class="pie-chart"></div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import * as echarts from "echarts";

export default {
  name: "DeviceStatusChart",
  props: {
    totalOnline: {
      type: Number,
      default: 24,
    },
    totalOffline: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  watch: {
    totalOnline() {
      this.updateChart();
    },
    totalOffline() {
      this.updateChart();
    },
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.pieChart);
      this.updateChart();
    },

    updateChart() {
      const onlineCount = this.totalOnline - this.totalOffline;

      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: "5%",
          top: "center",
          itemGap: 20,
          textStyle: {
            fontSize: 14,
            color: "#fff",
          },
          data: ["在线设备", "离线设备(>24h)"],
        },
        series: [
          {
            name: "设备状态",
            type: "pie",
            radius: ["55%", "75%"],
            center: ["35%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: true,
                color: "#fff",
                fontSize: "16",
                fontWeight: "bold",
                formatter: "{b}\n{c}台",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.2)",
              },
            },
            data: [
              {
                value: onlineCount,
                name: "在线设备",
                color: "#fff",
                label: {
                  textStyle: {
                    color: "#fff", // 设置在线设备文字为白色
                  },
                },
              },
              {
                value: this.totalOffline,
                name: "离线设备(>24h)",
                itemStyle: {
                  color: "#ff7c7c",
                },
                label: {
                  textStyle: {
                    color: "#fff", // 设置在线设备文字为白色
                  },
                },
              },
            ],
          },
        ],
      };

      this.chart.setOption(option);
    },

    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>
  
  <style scoped>
.totalNum {
  width: 100%;
  margin: 20px auto;
}

.totalNum__container {
  display: flex;
  /* background-color: #fff; */
  border-radius: 16px;
  color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 20px;
  overflow: hidden;
}

.info-cards {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.info-card {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  /* background-color: #f9fbff; */
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.info-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
}

.total-device::before {
  background-color: #58d9f9;
}

.offline-device::before {
  background-color: #ff7c7c;
}

.device-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background-color: rgba(88, 217, 249, 0.15);
  color: #58d9f9;
  font-size: 22px;
  font-weight: 600;
  margin-right: 20px;
}

.device-icon.offline {
  background-color: rgba(255, 124, 124, 0.15);
  color: #ff7c7c;
}

.device-info {
  flex: 1;
}

.info-title {
  margin: 0 0 8px;
  font-size: 14px;
  color: #fff;
}

.info-count {
  margin: 0;
  font-size: 30px;
  font-weight: 600;
  color: #58d9f9;
  line-height: 1;
}

.info-count.offline {
  color: #ff7c7c;
}

.chart-container {
  flex: 1;
  min-width: 320px;
  height: 250px;
}

.pie-chart {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .totalNum__container {
    flex-direction: column;
  }

  .chart-container {
    margin-top: 20px;
    height: 200px;
  }
}
</style>